// talkBridge — module-mutable channel (same pattern as beatBridge/gaitBridge):
// the DOM voice-chat hook writes per-frame speech amplitude here; the 3D
// AnimatedResident reads it in useFrame to drive a talking head-gesture WITHOUT
// forcing React re-renders. `talking` is the coarse gate (also mirrored into
// worldStore.residentTalking for the clip crossfade); `amplitude` is 0..~1 RMS
// of the current reply audio.
//
// NOTE: the rigged mesh has NO jaw bone / visemes yet, so amplitude drives the
// BODY (head/torso) today. When a face rig lands, point `amplitude` (or a real
// viseme timeline) at the jaw/morphs — see project_char_lipsync_performance.
export const talkBridge = { talking: false, amplitude: 0 };
